// Generated by `npm run reeffish` (scripts/reefFish.ts): the balance the manini's stocks open at,
// NOAA's divers' count of it at Maui Nui (./reefSurveys.ts) and its fishing in the State's fished areas (Longenecker et al. 2008), its larvae settling as
// Wren et al.'s model sends them (./exchange.ts, from data/bcodmo-665467/). Do not edit by hand.
// tests/maniniTaape.test.ts holds the balance to a year's step.
import type { FishJanuary, FishSupply } from '../../fish';
import { REEF_FISH_EXCHANGE } from './exchange';

/** The exchange, and the balance's larvae a kilogram of spawners sends, fishing and the rest's spawners. */
export const MANINI_SUPPLY: FishSupply = {
  exchange: REEF_FISH_EXCHANGE,
  larvaePerKgDay: 598.203,
  fishingPerYear: 0.58484,
  restSpawnersKg: 37891.4,
};

/** The balance's first of January (expected values; a world opening rounds the fish): each island's fish by month of age since settling, and the larvae afloat by their days to settle from that day. */
export const MANINI_JANUARY: FishJanuary = {
  islands: [
    [0, 0, 71492.9, 61623.3, 48311.3, 45788, 37433.3, 32061.3, 26421, 21720.5, 14660.4, 0, 0, 0, 6893.66, 5654.06, 4217.85, 3809.94, 2963.83, 2419.36, 1897.16, 1491.16, 960.362, 0, 0, 0, 451.041, 369.935, 275.967, 249.278, 193.918, 158.295, 124.128, 97.5638, 62.8349, 0, 0, 0, 29.5108, 24.2043, 18.0561, 16.3098, 12.6877, 10.357, 8.12149, 6.38343, 4.11118, 0, 0, 0, 1.93085, 1.58364, 1.18138, 1.06713, 0.830138, 0.677638, 0.531376, 0.417658, 0.268989, 0, 0.594295],
    [0, 0, 101849, 71957.9, 68612.1, 67313.2, 56648, 47028.4, 38777.7, 32930, 18461.1, 0, 0, 0, 9820.73, 6602.27, 5990.23, 5601.02, 4485.18, 3548.78, 2784.43, 2260.71, 1209.34, 0, 0, 0, 642.554, 431.975, 391.931, 366.465, 293.458, 232.19, 182.181, 147.915, 79.1249, 0, 0, 0, 42.0412, 28.2634, 25.6434, 23.9772, 19.2004, 15.1918, 11.9198, 9.67781, 5.17701, 0, 0, 0, 2.75069, 1.84923, 1.6778, 1.56879, 1.25625, 0.993975, 0.77989, 0.633204, 0.338726, 0, 0.829497],
    [0, 0, 34631.1, 30881, 23846.1, 22741.1, 18754.2, 16075.5, 13332.3, 11240.4, 8775.07, 0, 0, 0, 3339.28, 2833.39, 2081.91, 1892.24, 1484.89, 1213.06, 957.322, 771.678, 574.831, 0, 0, 0, 218.484, 185.384, 136.216, 123.806, 97.1537, 79.3686, 62.636, 50.4896, 37.6103, 0, 0, 0, 14.295, 12.1294, 8.91236, 8.10045, 6.3566, 5.19295, 4.09817, 3.30345, 2.46078, 0, 0, 0, 0.9353, 0.793604, 0.583121, 0.529999, 0.415902, 0.339766, 0.268136, 0.216139, 0.161005, 0, 0.297049],
    [0, 0, 4555.61, 4298.14, 3110.72, 2985.14, 2452.84, 2100.13, 1755.41, 1443.28, 1182.69, 0, 0, 0, 439.272, 394.363, 271.584, 248.388, 194.206, 158.476, 126.047, 99.0839, 77.4747, 0, 0, 0, 28.7408, 25.8025, 17.7693, 16.2516, 12.7066, 10.3688, 8.24706, 6.48289, 5.06904, 0, 0, 0, 1.88046, 1.68821, 1.16261, 1.06332, 0.831371, 0.678416, 0.539592, 0.424165, 0.331659, 0, 0, 0, 0.123036, 0.110457, 0.0760679, 0.0695711, 0.0543952, 0.0443877, 0.0353046, 0.0277524, 0.0216999, 0, 0.0393923],
  ],
  afloat: [
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
  ],
};
